// @flow
import { connect } from 'react-redux';
import memoize from 'fast-memoize';
import type { State } from '../../../../types';
import { generalConfigSelector } from '../../../../selectors/configSelectors';
import { drawingSelector } from '../../../../selectors/zoneSelectors';
import Targets from '../Targets';
import type { Props } from '../Targets';

const createLabelConfig = memoize((enabled, labelType, cluster) => ({
    enabled,
    labelType,
    cluster
}));

const mapStateToProps = (state: State) => {
    const generalConfig = generalConfigSelector(state);

    return {
        labelConfig: createLabelConfig(generalConfig.showLabels, generalConfig.labelType, generalConfig.clusterLabels),
        drawingEnabled: Boolean(drawingSelector(state))
    };
};

export default connect<Props, *, _, _, _, _>(mapStateToProps)(Targets);